import api from "../lib/api";

export const cartItemsToOrderItems = (items) => items.map((item) => ({
  product_id: item.product_id,
  name: item.name,
  price: item.price,
  size: item.size,
  qty: item.qty,
  image: item.image,
  slug: item.slug || "",
  product_url: item.slug ? `/product/${item.slug}` : "",
  sku: item.sku || "",
  color: item.color || "",
  variant_details: item.variant_details || {},
}));

export const buildCheckoutPayload = ({ form, items, paymentMethod, discountCode }) => ({
  customer: {
    ...form,
    shipping_address: {
      full_name: form.full_name,
      phone: form.phone,
      address_line1: form.address_line1,
      address_line2: form.address_line2,
      city: form.city,
      state: form.state,
      pincode: form.pincode,
      country: form.country || "India",
    },
  },
  items: cartItemsToOrderItems(items),
  payment_method: paymentMethod,
  discount_code: discountCode || null,
});

export const createOrder = async (payload) => {
  const { data } = await api.post("/orders", payload);
  return data;
};

export const getOrder = async (id) => {
  const { data } = await api.get(`/orders/${id}`);
  return data;
};

export const trackOrder = async (orderId, contact) => {
  const { data } = await api.get(`/orders/track/${encodeURIComponent(orderId.trim())}`, {
    params: contact ? { contact } : {},
  });
  return data;
};
